import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/authStore';
import { buildPath } from '../lib/tenant';

export function ProtectedRoute({ children }) {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to={buildPath(`/login?next=${encodeURIComponent(location.pathname + location.search)}`)} replace />;
    }

    return children;
}

export default ProtectedRoute;
